import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';

const tiers = [
  {
    id: 'assessment',
    name: 'ASSESSMENT - BASEBALL',
    subtitle: 'Individual Sessions',
    price: '$500',
    priceNote: 'FREE with 6-month+ commitment',
    highlight: false,
    badge: null,
    description: 'Perfect for athletes looking to know their metrics and peer ranking.',
    features: [
      'Single session booking',
      'Initial movement screen',
      'Velocity & arm health check',
      'Personalized session feedback',
      'All Data Collected Supplied to Player',
    ],
    cta: 'Get Started',
  },
  {
    id: 'junior',
    name: '10u - 13u',
    subtitle: 'MONTHLY JR. HIGH PROGRAM',
    price: '$325',
    priceNote: 'Billed Monthly',
    highlight: false,
    badge: null,
    description: 'Structured early development program to ensure the ability to play high school varsity sports.',
    features: [
      'Full initial assessment',
      'quarterly assesments',
      'Fundamental arm care and development',
      'Speed and Agility\u00a0',
      'Age appropriate strength development',
      'Mental performance foundation',
      'Proprioception and Impulse development',
      'Two days a week monthly',
      'Classes Monday & Wednesday, Tuesday & Thursday',
      'Limited to 10 athletes per class, 2 classes',
    ],
    cta: 'Get Started',
  },
  {
    id: 'middle-school',
    name: '14u - 16u',
    subtitle: 'MONTHLY HIGH SCHOOL PROGRAM BUILDING BLOCK',
    price: '$425',
    priceNote: 'Billed Monthly',
    highlight: false,
    badge: null,
    description: 'Bridge program designed to transition athletes from youth development into high school-level performance training.',
    features: [
      'Full initial assessment',
      'Quarterly assessments',
      'Arm care & velocity development',
      'Speed & agility training',
      'Strength & power foundation',
      'Mental performance coaching',
      'Advanced movement screening',
      'Two days a week monthly',
      'Classes Monday & Wednesday, Tuesday & Thursday',
      'Limited to 10 athletes per class, 2 classes',
    ],
    cta: 'Get Started',
  },
  {
    id: 'elite',
    name: 'High School / College',
    subtitle: 'Monthly Program',
    price: '$525',
    priceNote: 'Billed Monthly',
    highlight: false,
    badge: null,
    description: 'This is the ground up program. Focused on getting your high school player ready for college.',
    features: [
      'ArmCare Program Sponsored',
      'Group and Individualized programming',
      'Advanced Metric tracking',
      'Mental performance coaching',
      'Showcase & recruiting preparation',
      'Speed & agility integration',
      'Monthly benchmark testing',
      'Parent Guidance on the Process',
      'Helping the athlete develop and know their process',
      'Classes Monday & Wednesday, Tuesday & Thursday',
      'Limited to 10 athletes per class, 2 classes',
    ],
    cta: 'Get Started',
  },
  {
    id: 'college-pro',
    name: 'College / Pro Prep',
    subtitle: 'Full-Season Program',
    price: '$650',
    priceNote: 'Billed Monthly with 12 month Contract',
    highlight: false,
    badge: 'Elite 30',
    description: 'Built for athletes at the highest level preparing for the next step in their career.',
    features: [
      'ArmCare Program Sponsored',
      'Full-season plan',
      'Pro-level metrics & reporting',
      'Recruiting & agent coordination',
      'Nutrition & recovery guidance',
      'Unlimited session access',
      'Video remote coaching',
      'Summer Program',
      'Winter Program',
      'Mental Performance',
      'Limited to 30 Athletes',
    ],
    cta: 'Apply Now',
  },
  {
    id: 'summer',
    name: 'Summer Program',
    subtitle: 'Seasonal Intensive',
    price: '$1,500',
    priceNote: 'Per Month',
    highlight: false,
    badge: 'SUMMER',
    description: 'High-intensity summer training designed to maximize development during the off-season window.',
    features: [
      'Full assessment & baseline testing',
      'Daily training sessions Morning and Afternoon',
      'Velocity & mechanics development',
      'Speed & agility training',
      'Mental performance coaching',
      'ArmCare Program Sponsored',
      'Advanced metric tracking',
      'Showcase / Pro preparation\u00a0',
      'Nutrition & recovery guidance',
      'Summer Team Assistance',
      'Live AB\'s Weekly Saturdays',
      'Program Monday - Thursday',
    ],
    cta: 'Apply Now',
  },
  {
    id: 'winter',
    name: 'Winter Program',
    subtitle: 'Seasonal Intensive',
    price: '$1,500',
    priceNote: 'Per Month',
    highlight: false,
    badge: 'WINTER',
    description: 'Focused winter development program to build strength, refine mechanics, and prepare for the upcoming season.',
    features: [
      'Full assessment & baseline testing',
      'Daily training sessions Morning and Afternoon',
      'Strength & power development',
      'Mechanical refinement',
      'Mental performance coaching',
      'ArmCare Program Sponsored',
      'Advanced metric tracking',
      'Pre-season preparation',
      'Nutrition & recovery guidance',
      'Winter Team Assistance',
      'Live AB\'s Weekly Saturdays',
      'Program Monday - Thursday',
    ],
    cta: 'Apply Now',
  },
];

const addOns = [
  {
    id: 'one-on-one-strike',
    icon: 'ri-speed-up-line',
    title: '1 on 1 Strike-',
    price: '$599.00',
    description: 'In this one on one session you will get everything in the assessment, along with a training guide to help you get started in the right direction! No more guess work!',
  },
  {
    id: 'consultant',
    icon: 'ri-brain-line',
    title: 'Consultan Fees-',
    price: null,
    description: "Looking to find answers with your team's player development? Give us a call, first 30 min free.",
  },
  {
    id: 'remote-video',
    icon: 'ri-video-line',
    title: 'Remote Video Analysis-',
    price: '$250',
    description: 'Submit video from anywhere and receive detailed biomechanical feedback from our coaching staff.',
  },
  {
    id: 'team-group',
    icon: 'ri-group-line',
    title: 'Team / Group Packages-',
    price: null,
    description: 'Custom pricing for teams, travel ball organizations, and school programs. Contact us for a tailored quote.',
  },
];

const faqs = [
  {
    q: 'How do I know which program is right for me?',
    a: 'Every athlete starts with an initial assessment. Our coaches evaluate your mechanics, arm health, and goals to recommend the best program fit.',
  },
  {
    q: 'Can I upgrade my program mid-block?',
    a: 'Absolutely. If you want to step up to a higher tier during your training block, we\'ll prorate the difference and adjust your plan immediately.',
  },
  {
    q: 'Do you offer payment plans?',
    a: 'Yes. Monthly billing is available on all multi-week programs. Contact us to set up a payment schedule that works for you.',
  },
  {
    q: 'Is there a minimum age requirement?',
    a: 'We work with athletes ages 8 and up. Programs are fully customized to the athlete\'s age, development stage, and goals.',
  },
  {
    q: 'What is your cancellation policy?',
    a: 'Individual sessions require 24-hour notice for cancellation. Program blocks are non-refundable, non transferable.',
  },
];

export default function PricingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-pricing';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Baseball Training Pricing | Elite Performance Lab",
      "description": "Transparent pricing for all baseball training programs at Elite Performance Lab in Corsicana, TX. Programs for ages 10u through professional, plus add-on services.",
      "url": `${import.meta.env.VITE_SITE_URL}/pricing`,
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": import.meta.env.VITE_SITE_URL },
          { "@type": "ListItem", "position": 2, "name": "Pricing", "item": `${import.meta.env.VITE_SITE_URL}/pricing` }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "Baseball Training Programs",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Assessment - Baseball", "description": "Full baseline evaluation — $500, FREE with 6-month+ commitment." },
          { "@type": "ListItem", "position": 2, "name": "10u–13u Junior Program", "description": "Monthly junior development program — $325/month." },
          { "@type": "ListItem", "position": 3, "name": "14u–16u High School Building Block", "description": "Bridge program for high school preparation — $425/month." },
          { "@type": "ListItem", "position": 4, "name": "High School / College Program", "description": "Ground-up college prep program — $525/month." },
          { "@type": "ListItem", "position": 5, "name": "College / Pro Prep (Elite 30)", "description": "Full-season elite program limited to 30 athletes — $650/month." },
          { "@type": "ListItem", "position": 6, "name": "Summer Program", "description": "High-intensity summer training — $1,500/month." },
          { "@type": "ListItem", "position": 7, "name": "Winter Program", "description": "Focused winter development — $1,500/month." }
        ]
      },
      "speakable": {
        "@type": "SpeakableSpecification",
        "cssSelector": ["h1", "h2"]
      }
    });
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-pricing');
      if (el) el.remove();
    };
  }, []);

  const goToContact = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('contact');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <Navigation />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/72663ec31f587490d9becdf6b1ac5a20.jpg"
          alt="EPL Facility"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-gray-900"></div>
        <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
          <p className="text-teal-400 text-sm font-semibold tracking-widest uppercase mb-4">Transparent Pricing</p>
          <h1 className="text-5xl lg:text-6xl font-black text-white mb-6 leading-tight">
            Invest in Your <span className="text-teal-400">Career</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Every program at Elite Performance Lab is built around your individual goals. Choose the tier that fits your ambition — then let us help you exceed it.
          </p>
        </div>
      </section>

      {/* Pricing Tiers */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {tiers.map((tier, i) => (
              <div
                key={i}
                className={`relative rounded-2xl p-7 flex flex-col transition-all duration-300 hover:scale-105 ${
                  tier.highlight
                    ? 'bg-gradient-to-br from-teal-600/30 to-teal-500/10 border-2 border-teal-500 shadow-2xl shadow-teal-500/20'
                    : 'bg-gray-800 border border-gray-700 hover:border-teal-500/50'
                }`}
              >
                {tier.badge && (
                  <div className={`absolute -top-4 left-1/2 -translate-x-1/2 text-xs font-black px-5 py-1.5 rounded-full whitespace-nowrap tracking-widest uppercase shadow-lg ${
                    tier.badge === 'Elite 30'
                      ? 'bg-gradient-to-r from-amber-400 via-orange-400 to-yellow-300 text-gray-900 shadow-amber-400/50 ring-2 ring-amber-300/60'
                      : tier.badge === 'SUMMER'
                        ? 'bg-gradient-to-r from-orange-500 via-rose-500 to-pink-400 text-white shadow-orange-500/60 ring-2 ring-orange-400/60'
                        : tier.badge === 'WINTER'
                          ? 'bg-gradient-to-r from-sky-400 via-cyan-400 to-teal-300 text-gray-900 shadow-cyan-400/60 ring-2 ring-cyan-300/60'
                          : tier.highlight
                            ? 'bg-teal-500 text-white'
                            : 'bg-gray-600 text-gray-200'
                  }`}>
                    {tier.badge === 'Elite 30' && <span className="mr-1">⚡</span>}
                    {tier.badge === 'SUMMER' && <span className="mr-1">☀️</span>}
                    {tier.badge === 'WINTER' && <span className="mr-1">❄️</span>}
                    {tier.badge}
                    {tier.badge === 'Elite 30' && <span className="ml-1">⚡</span>}
                    {tier.badge === 'SUMMER' && <span className="ml-1">🔥</span>}
                    {tier.badge === 'WINTER' && <span className="ml-1">❄️</span>}
                  </div>
                )}

                <div className="mb-6">
                  <h3 className="text-xl font-black text-white mb-1">{tier.name}</h3>
                  <p className="text-teal-400 text-sm font-medium">{tier.subtitle}</p>
                </div>

                <div className="mb-5">
                  <div className="text-2xl font-black text-white">{tier.price}</div>
                  {tier.priceNote && (
                    <p className={`text-xs mt-1 ${tier.name === 'ASSESSMENT - BASEBALL' ? 'text-teal-400 font-semibold' : 'text-gray-400'}`}>
                      {tier.priceNote}
                    </p>
                  )}
                </div>

                <p className="text-gray-300 text-sm leading-relaxed mb-6">{tier.description}</p>

                <ul className="space-y-3 mb-8 flex-1">
                  {tier.features.map((f, fi) => {
                    const isLimited = f === 'Limited to 30 Athletes' || f === 'Limited to 10 athletes per class, 2 classes';
                    const isSchedule = f === 'Classes Monday & Wednesday, Tuesday & Thursday';
                    return isLimited ? (
                      <li key={fi} className="flex items-center gap-2 mt-4 px-3 py-2.5 rounded-xl bg-gradient-to-r from-amber-500/20 to-orange-500/10 border border-amber-400/50 shadow-sm shadow-amber-500/10">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i className="ri-fire-fill text-amber-400 text-base"></i>
                        </div>
                        <span className="text-amber-300 text-sm font-bold tracking-wide">
                          {f}
                        </span>
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 ml-auto">
                          <i className="ri-lock-fill text-amber-400/70 text-xs"></i>
                        </div>
                      </li>
                    ) : isSchedule ? (
                      <li key={fi} className="flex items-center gap-2 mt-2 px-3 py-2.5 rounded-xl bg-gradient-to-r from-teal-500/15 to-teal-400/5 border border-teal-500/40">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                          <i className="ri-calendar-schedule-line text-teal-400 text-base"></i>
                        </div>
                        <span className="text-teal-300 text-sm font-semibold">
                          {f}
                        </span>
                      </li>
                    ) : (
                      <li key={fi} className="flex items-start gap-3">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-check-line text-teal-400 text-base"></i>
                        </div>
                        <span className="text-gray-300 text-sm">{f}</span>
                      </li>
                    );
                  })}
                </ul>

                <button
                  onClick={goToContact}
                  className={`w-full py-3 rounded-xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                    tier.highlight
                      ? 'bg-teal-500 text-white hover:bg-teal-400 shadow-lg'
                      : 'bg-gray-700 text-white hover:bg-teal-500 border border-gray-600 hover:border-teal-500'
                  }`}
                >
                  {tier.cta}
                </button>

                <button
                  onClick={() => navigate(`/package/${tier.id}`)}
                  className="w-full py-3 rounded-xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap mt-3 bg-transparent text-teal-400 border border-teal-500/50 hover:bg-teal-500/10 hover:border-teal-400"
                >
                  Learn More
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Add-Ons */}
      <section className="py-20 bg-gray-800">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">Other Services</h2>
            <div className="w-20 h-1 bg-teal-500 mx-auto mb-4"></div>
            <p className="text-gray-300 max-w-2xl mx-auto text-sm leading-relaxed">
              Enhance any program tier with specialized add-ons designed to cover every dimension of your development.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {addOns.map((a, i) => (
              <div key={i} className="bg-gray-900 rounded-2xl p-7 border border-gray-700 hover:border-teal-500 transition-all duration-300 hover:shadow-xl flex flex-col">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-xl mb-5">
                  <i className={`${a.icon} text-2xl text-teal-400`}></i>
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{a.title}</h3>
                {a.price && (
                  <div className="text-2xl font-black text-teal-400 mb-3">{a.price}</div>
                )}
                <p className="text-gray-400 text-sm leading-relaxed flex-1">{a.description}</p>
                <button
                  onClick={() => navigate(`/addon/${a.id}`)}
                  className="mt-6 w-full py-2.5 rounded-xl text-sm font-semibold text-teal-400 border border-teal-500/50 hover:bg-teal-500/10 hover:border-teal-400 transition-all cursor-pointer whitespace-nowrap"
                >
                  More Info
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-center mb-14">
            <h2 className="text-3xl lg:text-4xl font-black text-white mb-4">Frequently Asked Questions</h2>
            <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <FaqItem key={i} q={faq.q} a={faq.a} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-20 bg-gradient-to-r from-teal-700 to-teal-500">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-black text-white mb-4">Not Sure Where to Start?</h2>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Reach out and our coaches will help you find the right program for your age, level, and goals. No pressure — just results.
          </p>
          <button
            onClick={goToContact}
            className="px-10 py-4 bg-white text-teal-700 text-base font-bold rounded-full hover:bg-gray-100 transition-all shadow-2xl cursor-pointer whitespace-nowrap"
          >
            Talk to a Coach
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-gray-800 rounded-xl border border-gray-700 overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
      >
        <span className="text-white font-semibold text-sm pr-4">{q}</span>
        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
          <i className={`text-teal-400 text-lg transition-transform duration-300 ${open ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
        </div>
      </button>
      {open && (
        <div className="px-6 pb-5">
          <p className="text-gray-400 text-sm leading-relaxed">{a}</p>
        </div>
      )}
    </div>
  );
}